<template>
  <div id="questionList" class="container">
    <div v-if="this.loading" class="loading">
      <v-progress-circular
        :size="70"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <mock-print
      autoPrint
      :selected_mock.sync="mock"
      @close="dialogPrint = false"
      :dialog.sync="dialogPrint"
    ></mock-print>
    <v-container v-if="this.totalQuestions" class="mx-auto" fluid grid-list-xl>
      <div v-if="result">
        <shark-swim
          :enabled="
            result.finalScore > 95 &&
            this.totalQuestions > 30 &&
            this.mock.mode !== 1
          "
        />
      </div>
      <v-layout class="pagination-actions">
        <v-pagination
          v-model="currentQuestion"
          :length="totalQuestions"
          :total-visible="5"
          style="width: auto"
          @input="saveQuestionsToLocalStorage()"
        />
        <div class="d-flex align-center justify-between flex-nowrap">
          <mock-timer
            id="timer"
            :disabled="this.mock.mode === 1 || mockFinished"
            :seconds="timeLeft"
            @timeOver="onTimeOver"
            @timeUpdate="onTimeUpdate"
          ></mock-timer>
          <div v-if="result">
            <mock-result
              :disabled="!mockFinished"
              :reviewQuestions="false"
              :mockLogId="this.mock.mock_log_id"
              :score="result.rightAnswers"
              :totalQuestions="totalQuestions"
            />
          </div>
          <v-btn text style="margin-right: 8px" @click="printMock()">
            <svg
              style="width: 24px; height: 24px; margin-right: 12px"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"
              />
            </svg>
          </v-btn>
          <v-btn
            rounded
            elevation="0"
            style="margin-right: 8px"
            v-if="!this.mockFinished"
            color="secondary"
            @click="pauseMock(false)"
          >
            <v-icon>pause</v-icon>
            <v-flex v-if="$vuetify.breakpoint.mdAndUp">Pausar</v-flex>
          </v-btn>
          <v-btn
            rounded
            elevation="0"
            style="margin-right: 10px"
            v-if="!mockFinished && this.mock.mode === 2"
            :disabled="
              mockFinished || this.questions[this.currentQuestion - 1].finished
            "
            color="primary"
            @click="checkAnswers(false)"
          >
            <v-icon>done_all</v-icon>
            <v-flex v-if="$vuetify.breakpoint.mdAndUp">Finalizar</v-flex>
          </v-btn>
          <v-btn
            rounded
            style="margin-right: 10px"
            v-if="!mockFinished && this.mock.mode === 1"
            :disabled="
              mockFinished || this.questions[this.currentQuestion - 1].finished
            "
            color="primary"
            @click="checkAnswer()"
          >
            <v-icon>done</v-icon>
            <v-flex v-if="$vuetify.breakpoint.mdAndUp">Corrigir</v-flex>
          </v-btn>
        </div>
      </v-layout>
      <v-container fluid grid-list-xl>
        <question
          :disabled="questions[currentQuestion - 1].finished || reviewMode"
          :loading="this.loading"
          :mode="this.mock.mode"
          :question="questions[currentQuestion - 1]"
          @checkAnswer="checkAnswer()"
          @checkAnswers="checkAnswers()"
          @pauseMock="pauseMock()"
        />
      </v-container>
    </v-container>
    <message-card
      v-if="this.totalQuestions === 0"
      :cta="{ title: 'Tentar outro critério', route: 'mocks.search' }"
      icon="/img/beer-mug.svg"
      subtitle="O critério aplicado não resultou em nenhuma questão"
      title="Está vazio aqui"
    >
    </message-card>
    <v-dialog v-model="leaveDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline"
          >Não está esquecendo de algo?</v-card-title
        >
        <v-card-text
          >Seu simulado está em andamento, tem certeza que deseja
          sair?</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="confirmLeave(false)"
            >Permanecer</v-btn
          >
          <v-btn color="red darken-1" text @click="confirmLeave(true)"
            >Sair</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout justify-center row>
      <v-dialog v-model="dialog" max-width="300" persistent>
        <v-card>
          <v-card-title class="headline"
            >Não está esquecendo de algo?</v-card-title
          >
          <v-card-text
            >Parece que você esqueceu de responder uma ou mais questões. O que
            você deseja fazer?</v-card-text
          >
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1" text @click="dialog = false"
              >Revisar</v-btn
            >
            <v-btn color="red darken-1" text @click="checkAnswers(true)"
              >Finalizar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout justify-center row>
      <v-dialog v-model="dialogLogin" max-width="300" persistent>
        <v-card>
          <login-form @login="onLogin" />
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import QuestionFilter from "@/components/quiz/QuestionFilter";
import Question from "@/components/quiz/Question";
import MockService from "@/services/mocks.service";
import MockLogsService from "@/services/mockLogs.service";
import MockResult from "@/components/quiz/MockResult.vue";
import MockPrint from "@/components/quiz/MockPrint";
import SharkSwim from "../../components/animation/SharkSwim";
import MessageCard from "../../components/widgets/card/MessageCard";
import MockTimer from "../../components/quiz/MockTimer";
import LoginForm from "../../components/widgets/form/LoginForm.vue";

export default {
  components: {
    MockTimer,
    MessageCard,
    SharkSwim,
    QuestionFilter,
    Question,
    MockPrint,
    MockResult,
    LoginForm,
  },
  metaInfo() {
    return {
      title: "LS - Simulado de Questões de Certificação",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Resolva questões de testes ou simulados de questões de certificação",
        },
      ],
    };
  },
  data() {
    return {
      filter: {
        courses: [],
        topics: [],
        subjects: [],
      },
      answers: null,
      paused: false,
      dialog: false,
      currentQuestion: null,
      totalQuestions: null,
      option: null,
      loading: false,
      questions: [],
      mockFinished: false,
      mockFinishing: false,
      selected_mock: null,
      dialogPrint: false,
      mock: null,
      reviewMode: false,
      leaveDialog: false,
      leaveNext: null,
      leaveResolve: null,
      result: {
        finalScore: null,
      },
      timeLeft: 30 * 100,
      dialogLogin: false,
      tryFinishMockBeforeAuthenticate: false,
    };
  },
  computed: {
    authenticated() {
      return this.$store.state.auth.user !== null;
    },
  },
  created() {
    window.addEventListener("beforeunload", this.beforeUnload);

    const query = this.$route.query;
    query.include = "questions";
    if (this.$route.params.id === "review") {
      this.reviewMode = true; // Add this line
      MockLogsService.getInfo(query.mockLogId)
        .then((resp) => {
          this.mockFinished = true;
          this.mockFinishing = true;
          this.result = resp.data;
          this.result.rightAnswers = this.result.questions.data.filter(
            (question) => question.correct === "1",
          ).length;
          this.showResults = true;
          this.mock = resp.data;
          this.mock.mock_log_id = query.mockLogId;
          this.timeLeft = this.mock.time_left;
          if (this.$route.params.id === "new") {
            this.mock.mode = parseInt(this.$route.query.mode);
          }
          if (!isNaN(this.$route.params.id)) {
            this.mock.mode = 2; // Its a Mock like CPA-10, 20, CEA etc...
          }
          this.questions = resp.data.questions.data;
          console.log("questions", this.questions);
          this.totalQuestions = this.questions.length;
          this.mapQuestions(resp.data.questions.data);
          this.currentQuestion = 1;
          this.loading = false;
        })
        .catch((error) => {
          console.log("error", error);
        });
    } else {
      this.loadMock();
    }
    if (!this.authenticated) {
      window.getApp.sendSnackMessage(
        "Você precisa estar logado para corrigir as questões 😉",
      );
    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (this.mockFinishing || this.paused) {
      next();
    } else {
      this.leaveDialog = true;
      this.leaveNext = next;
    }
  },
  methods: {
    confirmLeave(confirm) {
      if (confirm) {
        const key = `mock_${this.mock.mock_log_id}`;
        localStorage.removeItem(key);
        this.leaveNext();
      } else {
        this.leaveNext(false);
      }
      this.leaveDialog = false;
      this.leaveNext = null;
    },
    beforeUnload(event) {
      if (!this.mockFinishing || !this.paused) {
        event.preventDefault();
        console.log("teste antes do click");
        const confirmationMessage =
          "Você tem certeza que deseja sair? Suas respostas não salvas serão perdidas.";
        const key = `mock_${this.mock.mock_log_id}`;
        const storedData = JSON.parse(localStorage.getItem(key));
        if (storedData) {
          storedData.status = "saindo";
          localStorage.setItem(key, JSON.stringify(storedData));
        }
        if (confirm(confirmationMessage)) {
          return;
        } else {
          storedData.status = null;
          event.returnValue = false;
        }
      }
    },

    async printMock() {
      this.dialogPrint = true;
    },
    async onLogin() {
      this.dialogLogin = false;
      if (this.tryFinishMockBeforeAuthenticate) {
        this.checkAnswers(false);
      }
    },
    loadMock() {
      this.loading = true;
      const query = this.$route.query;
      query.include = "questions";
      MockService.getByIdPublic(this.$route.params.id, query)
        .then((resp) => {
          this.mock = resp.data;
          this.timeLeft = this.mock.time_left;
          if (this.$route.params.id === "new") {
            this.mock.mode = parseInt(this.$route.query.mode);
          }
          if (!isNaN(this.$route.params.id)) {
            this.mock.mode = 2; // Its a Mock like CPA-10, 20, CEA etc...
          }
          this.questions = resp.data.questions.data;
          this.totalQuestions = this.questions.length;
          this.mapQuestions(resp.data.questions.data);
          this.currentQuestion = 1;
          this.loading = false;
        })
        .catch(console.log);
    },
    saveQuestionsToLocalStorage() {
      // evita sobreescrever simulados finalizados
      if (this.$route.params.id === "review") {
        return;
      }
      const data = {
        mockId: this.mock.mock_log_id,
        questions: this.questions.map((question) => ({
          id: question.id,
          answer: question.answer,
        })),
      };
      localStorage.setItem(
        `mock_${this.mock.mock_log_id}`,
        JSON.stringify(data),
      );
    },
    changeQuestions(newQuestions) {
      this.loading = true;
      this.questions = newQuestions;
      this.totalQuestions = this.questions.length;
      this.currentQuestion = 1;
      this.loading = false;
    },
    isAuth() {
      if (!this.authenticated) {
        window.getApp.sendSnackMessage(
          "Você precisa estar logado para corrigir as questões 😉",
        );
        return false;
      } else return true;
    },
    checkAnswers(ignoreBlanks = false) {
      this.mockFinishing = true;
      this.saveQuestionsToLocalStorage();
      const key = `mock_${this.mock.mock_log_id}`;
      const storedData = JSON.parse(localStorage.getItem(key));

      if (storedData) {
        storedData.status = "finalizando";
        localStorage.setItem(key, JSON.stringify(storedData));
      }
      if (!this.authenticated) {
        this.dialogLogin = true;
        window.getApp.sendSnackMessage(
          "Você precisa estar logado para corrigir as questões 😉",
        );
        this.tryFinishMockBeforeAuthenticate = true;
        return;
      }
      this.dialog = false;
      const res = this.existBlanks();
      if (!ignoreBlanks && res) {
        this.dialog = true;
        return;
      }
      this.loading = true;
      const answers = this.questions.map((elem) => {
        return { id: elem.id, answer: elem.answer };
      });
      MockService.checkAnswers(this.mock.mock_log_id, answers)
        .then((resp) => {
          this.answers = resp.data.questions;
          this.result = resp.data.result;
          this.mapQuestions(resp.data.questions);
          this.currentQuestion = 1;
          this.mockFinished = true;
          this.reviewMode = true;
          this.loading = false;
          localStorage.removeItem(key);
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error checking answers:", error);
        });
    },
    checkAnswer() {
      this.saveQuestionsToLocalStorage();
      if (!this.isAuth()) return;
      this.loading = true;
      const answers = [
        {
          id: this.questions[this.currentQuestion - 1].id,
          answer: this.questions[this.currentQuestion - 1].answer,
        },
      ];
      MockService.checkAnswers(this.mock.mock_log_id, answers, false).then(
        (resp) => {
          this.answers = resp.data.questions;
          this.result = resp.data.result;
          this.questions = this.questions.map((item) => {
            const q = resp.data.questions.findIndex((q) => {
              return q.id === item.id;
            });
            if (q > -1) {
              item.correct_answer = resp.data.questions[q].correct_answer;
              item.correct = resp.data.questions[q].correct;
              item.finished = true;
            }
            return item;
          });
          this.loading = false;
          if (!this.thereAreQuestionsLeft() && this.mock.mode === 1) {
            this.checkAnswers(true);
          }
        },
      );
    },
    thereAreQuestionsLeft() {
      const thereAre = this.questions.find((q) => {
        return q.finished !== true;
      });
      return !(thereAre === undefined);
    },
    pauseMock() {
      this.saveQuestionsToLocalStorage();
      this.paused = true;
      if (!this.isAuth()) return;
      this.dialog = false;
      this.loading = true;
      const answers = this.questions.map((elem) => {
        return { id: elem.id, answer: elem.answer };
      });
      MockService.pauseMock(this.mock.mock_log_id, answers)
        .then((resp) => {
          this.answers = resp.data.questions;
          this.result = resp.data.result;
          this.loading = false;
          this.finished = true;
          const key = `mock_${this.mock.mock_log_id}`;
          localStorage.removeItem(key);
          this.$router.push({ name: "mocks.logs" });
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error pausing mock:", error);
        });
    },
    existBlanks() {
      const blanks = this.questions.find((q) => {
        return q.answer == null;
      });
      return !(blanks === undefined);
    },
    mapQuestions(questionsArray) {
      this.questions = this.questions.map((item) => {
        const q = questionsArray.findIndex((q) => {
          return q.id === item.id;
        });
        if (q > -1) {
          item.correct_answer = questionsArray[q].correct_answer;
          item.correct = questionsArray[q].correct;
          item.finished = item.correct !== undefined && item.correct !== null;
        } else {
          item.correct_answer = null;
          item.correct = null;
          item.finished = false;
        }
        return item;
      });
    },
    onTimeOver() {
      this.timeLeft = 0;
      this.checkAnswers(true);
    },
    onTimeUpdate(secondsLeft) {
      this.timeLeft = secondsLeft;
    },
  },
};
</script>
<style lang="scss" scoped>
#questionList {
  max-width: 1200px;
}
.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.571);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.pagination-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 15px !important;
  @media (max-width: 700px) {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
